<template lang="pug">
  tbody
    tr
      th(rowspan=3) {{ $t("ui.sportsbook") }}
      th {{ soccer_hdp_title }}
      td.text-center {{ soccer_hdp_upline_pt }}%
      td.text-center(v-show="isSearch") {{ soccer_hdp_account_pt }}%
      td.text-center(v-show="isSearch") {{ soccer_hdp_upline_remaining}}%
      td.text-center(v-show="isSearch") {{ soccer_hdp_account_min }}%
    tr
      th {{ soccer_1x2_title }}
      td.text-center {{ soccer_1x2_upline_pt }}%
      td.text-center(v-show="isSearch") {{ soccer_1x2_account_pt }}%
      td.text-center(v-show="isSearch") {{ soccer_1x2_upline_remaining}}%
      td.text-center(v-show="isSearch") {{ soccer_1x2_account_min }}%
    tr
      th {{ soccer_others_title }}
      td.text-center {{ soccer_others_upline_pt }}%
      td.text-center(v-show="isSearch") {{ soccer_others_account_pt }}%
      td.text-center(v-show="isSearch") {{ soccer_others_upline_remaining}}%
      td.text-center(v-show="isSearch") {{ soccer_others_account_min }}%
    tr(v-if="['MMK','MMO'].includes($store.getters.getAccountCurrency)")
      th {{ $t("ui.sportsbook") }} MMO
      th {{ hdp_mmo_title }}
      td.text-center {{ hdp_mmo_upline_pt }}%
      td.text-center(v-show="isSearch") {{ hdp_mmo_account_pt }}%
      td.text-center(v-show="isSearch") {{ hdp_mmo_upline_remaining}}%
      td.text-center(v-show="isSearch") {{ hdp_mmo_account_min }}%
</template>

<script>
export default {
  props: {
    isSearch: false
  },
  data() {
    return {
      soccer_hdp_upline_min: 0,
      soccer_hdp_upline_max: 0,
      soccer_hdp_upline_pt: 0,
      soccer_hdp_account_pt: 0,
      soccer_hdp_upline_remaining: 0,
      soccer_hdp_account_min: 0,
      soccer_1x2_upline_min: 0,
      soccer_1x2_upline_max: 0,
      soccer_1x2_upline_pt: 0,
      soccer_1x2_account_pt: 0,
      soccer_1x2_upline_remaining: 0,
      soccer_1x2_account_min: 0,
      soccer_others_upline_min: 0,
      soccer_others_upline_max: 0,
      soccer_others_upline_pt: 0,
      soccer_others_account_pt: 0,
      soccer_others_upline_remaining: 0,
      soccer_others_account_min: 0,

      hdp_mmo_upline_min: 0,
      hdp_mmo_upline_max: 0,
      hdp_mmo_upline_pt: 0,
      hdp_mmo_account_pt: 0,
      hdp_mmo_upline_remaining: 0,
      hdp_mmo_account_min: 0,
    }
  },
  computed: {
    soccer_hdp_title: function () {
      return this.$t("ui.hdp") + "/" + this.$t("ui.ou") + "/" + this.$t("ui.oe") + " (" + this.soccer_hdp_upline_min + "%-" + this.soccer_hdp_upline_max + "%)"
    },
    soccer_1x2_title: function() {
      return this.$t("ui.oxt") + "/" + this.$t("ui.double_chance") + "/" + this.$t("ui.money_line") + " (" + this.soccer_1x2_upline_min + "%-" + this.soccer_1x2_upline_max + "%)"
    },
    soccer_others_title: function() {
      return this.$t("ui.others") + " (" + this.soccer_others_upline_min + "%-" + this.soccer_others_upline_max + "%)"
    },
    hdp_mmo_title: function () {
      return this.$t("ui.hdp") + "/" + this.$t("ui.ou") + " (" + this.hdp_mmo_upline_min + "%-" + this.hdp_mmo_upline_max + "%)"
    }
  }
}

</script>